import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { PaywallAppSteps } from '@/pages/Paywall/components/AppStep';

import { HowItWorksStyles } from './HowItWorks.styles';

interface PaywallHowItWorksProps {
  theme?: 'dark-violet' | 'domination' | null;
}

export const SectionHowItWorks: React.FC<PaywallHowItWorksProps> = ({
  theme,
}) => {
  return (
    <HowItWorksStyles>
      <OnboardingTitle className="how-it-works-title">
        How it{' '}
        <UiTypography
          variant="inherit"
          component="span"
          color={theme === 'domination' ? 'red-gradient' : 'gradient'}
        >
          works
        </UiTypography>
      </OnboardingTitle>

      <PaywallAppSteps
        stepGetPlanBgUrl="../assets/paywall/fast-pay-tabs-domination/phone.png"
        stepDiveInBgUrl="../assets/paywall/fast-pay-tabs-domination/chat.png"
        stepExploreBgUrl="../assets/paywall/fast-pay-tabs-domination/icons.png"
      />
    </HowItWorksStyles>
  );
};
